module.exports = __webpack_public_path__ + "img/biao2.af5e7c01.webp";